import React, { Component } from 'react';
import { AdvanceList, AdvanceListItem } from '../../components/AdvanceList';
import includes from 'lodash/includes';
import * as analytics from 'shared/lib/analytics';
import './ClaimsMethods.css';

class ClaimsMethods extends Component {
  componentDidMount() {
    document.title = 'Claims | Select a repair method - Sure';
    analytics.page('Portal - Claim Repair Method', {
      category: 'claim',
      label: this.props.params.verticalCode,
    });
  }

  trackMethodClick(methodName) {
    const isDeviceMailedOut = methodName === 'mail';
    this.props.saveIsClaimsDeviceMailedOut(isDeviceMailedOut);
    analytics.track('Portal - Claim Repair Method Clicked', {
      category: 'claim',
      label: methodName,
    });
  }

  render() {
    const { verticalCode, policyNumber } = this.props.params;
    const storeLink = `/account/claims/new/${verticalCode}/policies/${policyNumber}/options`;
    const mailLink = `/account/claims/new/${verticalCode}/policies/${policyNumber}/damages`;

    return (
      <div className="ClaimsMethods">
        <div className="Container Container--small">
          <h1 className="ClaimsMethods-heading">
            Please choose your method of repair
          </h1>
          <AdvanceList>
            {includes(this.props.order.details.modal_name, 'iPhone') && (
              <AdvanceListItem
                linkTo={storeLink}
                title="Bring in for repair"
                details={[
                  'Make an appointment at an Apple Store. They’ll try to fix your iPhone during your visit.',
                ]}
                onClick={this.trackMethodClick.bind(this, 'store')}
              />
            )}
            <AdvanceListItem
              linkTo={mailLink}
              title="Send in for repair"
              details={[
                `Contact Sure, and we'll help you ship your device to one of our authorized repair centers.`,
              ]}
              onClick={this.trackMethodClick.bind(this, 'mail')}
            />
          </AdvanceList>
        </div>
      </div>
    );
  }
}

export default ClaimsMethods;
